import React from 'react';
import { inject, observer } from 'mobx-react';
import { Spring, animated } from 'react-spring';

import { formatCurrency } from 'js/services/Format';
import Container from './Container';
import Label from './Label';
import Value from './Value';
import Row from './Row';
import { Amount, Money } from './BottomRow';

import Buttons from './Buttons';
import ManageButton from './ManageButton';

export default inject('page')(
  observer(({ page }) => {
    const {
      alias,
      payment_method,
      buyer,
      title,
      actual_price,
      can_modify,
      order_shipping,
      is_buyer,
      toggleManageMenu,
      order_uid,
      has_order,
    } = page;

    return (
      <Spring native from={{ opacity: 0 }} to={{ opacity: 1 }}>
        {animation => (
          <animated.div style={animation}>
            <Container>
              {can_modify && (
                <Buttons>
                  <ManageButton onClick={toggleManageMenu} />
                </Buttons>
              )}

              {has_order && (
                <Row>
                  <Label>ORDER ID</Label>
                  <Value>{order_uid}</Value>
                </Row>
              )}

              <Row>
                <Label>OFFER ID</Label>
                <Value>#{alias.toUpperCase()}</Value>
              </Row>

              <Row>
                <Label>PREPAY METHOD</Label>
                <Value>{payment_method}</Value>
              </Row>

              <Row>
                <Label>FROM</Label>
                <Value>@{buyer}</Value>
              </Row>

              <Row>
                <Label>FOR</Label>
                <Value>{title}</Value>
              </Row>

              <Row>
                <Label>SHIPPING</Label>
                <Value>{is_buyer && order_shipping ? order_shipping : 'covered by buyer'}</Value>
              </Row>

              <Row>
                <Amount>AMOUNT</Amount>
                <Money>{formatCurrency(actual_price)}</Money>
              </Row>
            </Container>
          </animated.div>
        )}
      </Spring>
    );
  }),
);
